import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromSpinner from '../../reducers/spinner/spinner.reducer';

export const selectSpinnerState = createSelector(fromFeature.getSpinnerState, (state) => state);

export const selectSpinnerShow = createSelector(selectSpinnerState, fromSpinner.getSpinnerShow);
